import React, { useState, useEffect } from "react";

import cup from "../../../../../assets/images/cup 2.png";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import EnterImage from "../../../../../assets/images/unsplash_hUHzaiAHuUc.png";

import axios from "axios";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import PromotionalCard from "../../../../Reuseable/PromotionalCard";

const AuditionPromotionalList = () => {
  const [event_data, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/superstar/promotional/accepted/video/list").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.event);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title={" Accepted Auditions Promotional List"}
        image={cup}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <PromotionalCard
          data={event_data}
          urlLink={`/superstar/audition/promotional-view`}
        />
      )}
    </>
  );
};

export default AuditionPromotionalList;
